import React, { PureComponent } from 'react'

import { connect } from 'react-redux'

import { WhiteGloveOnboardingPlan } from '@driftt/billing-components'
import { Button } from '@driftt/tide-core'

import BOLTS_ICON from 'images/drift-bolts.svg'
import { getDeal, getDealRep } from 'modules/billing/selectors'
import { track } from 'utils/trackingUtils'

import DRIFT_LOGO from '../drift-logo.svg'

import CURVE_ARROW from './gradient-arrow.svg'

import './style.css'

const mapStateToProps = (state) => {
  const deal = getDeal(state) || {}
  const salesRep = getDealRep(state) || {}

  return {
    deal: deal,
    avatarUrl: salesRep.avatarUrl,
  }
}

class PlanSummary extends PureComponent {
  componentDidMount() {
    const { deal } = this.props

    if (deal.salesRepId) {
      window.drift.on('ready', () => {
        window.drift.config({ autoAssigneeId: deal.salesRepId })
      })
    }
  }

  openChatToRep = () => {
    window.drift.on('ready', () => {
      window.drift.api.openChat()
      track('Deal Flow - Get In Touch Clicked')
    })
  }

  render() {
    const { deal, avatarUrl } = this.props

    return (
      <div className="billing-plan-summary">
        <img
          className="billing-plan-summary-bolts"
          src={BOLTS_ICON}
          alt="Drift bolts"
        />
        <WhiteGloveOnboardingPlan deal={deal} />
        <div className="sales-rep-bottom-content">
          <img src={CURVE_ARROW} alt="curved arrow" />
          <div className="sales-rep-area">
            <img
              className="summary-rep-image"
              src={avatarUrl || DRIFT_LOGO}
              alt="This is your sales rep"
            />
            <div className="sales-rep-area--content">
              <p>This is the deal we discussed</p>
              <p>Something look off?</p>
              <Button type="tertiary" size="small" onClick={this.openChatToRep}>
                Talk to me
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(PlanSummary)
